import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d9f498ce"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "imageDropSpace" };
const _hoisted_2 = { class: "dragSpace" };
const _hoisted_3 = /*#__PURE__*/ _createTextVNode("Trascina l'immagine ");
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_5 = /*#__PURE__*/ _createTextVNode(" o clicca qui");
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", {
                class: "drag-drop",
                onDragover: _cache[1] || (_cache[1] = _withModifiers(() => { }, ["prevent"])),
                onDrop: _cache[2] || (_cache[2] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.dropImage && _ctx.dropImage(...args)), ["prevent"])),
                onClick: _cache[3] || (_cache[3] =
                    //@ts-ignore
                    (...args) => (_ctx.click && _ctx.click(...args)))
            }, [
                _createElementVNode("span", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "default", {}, () => [
                        _hoisted_3,
                        _hoisted_4,
                        _hoisted_5
                    ], true)
                ]),
                _createElementVNode("input", {
                    type: "file",
                    multiple: "true",
                    onChange: _cache[0] || (_cache[0] =
                        //@ts-ignore
                        (...args) => (_ctx.onFileSelect && _ctx.onFileSelect(...args))),
                    ref: "fileInput",
                    class: "hidden absolute"
                }, null, 544)
            ], 32)
        ])
    ]));
}
